import { render } from "./single.vue?vue&type=template&id=fb417d9e&scoped=true"
import script from "./single.vue?vue&type=script&lang=js"
export * from "./single.vue?vue&type=script&lang=js"

import "./single.vue?vue&type=style&index=0&id=fb417d9e&scoped=true&lang=css"

import exportComponent from "D:\\DAIHAO\\AAAAA\\smart_brain_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb417d9e"]])

export default __exports__